namespace AgerLMS {
    export enum LessonTypes {
        Upload = 0,
        Youtube = 1,
        Vimeo = 2,
        ExternalLink = 3,
        GoogleDrive = 4,
        iFrame = 5,
        AmazonS3 = 6
    }
    Serenity.Decorators.registerEnumType(LessonTypes, 'AgerLMS.LessonTypes');
}
